<template>
  <auth-guard
    route
  >
    <v-container fluid>
      <router-view />
    </v-container>
  </auth-guard>
</template>

<script>
export default {
  name: 'LotParent'
}
</script>
